<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>站点配置列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">是否开启：</el-text>
        <el-col :span="4">
          <el-radio label="是" v-model="isOpen"></el-radio>
          <el-radio label="否" v-model="isOpen"></el-radio>
        </el-col>
      </el-row>
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">提现公告：</el-text>
        <el-col :span="4">
          <el-input placeholder="请输入公告" style="width:400px;" v-model="withdrawNotice"></el-input>
        </el-col>
      </el-row>

      <el-row class="bt" style="padding:15px 0; padding-left: 100px;">
        <el-button type="primary" @click="submitEvent">确定</el-button>
        <el-button plain type="primary" @click="backEvent">返回</el-button>
      </el-row>
    </el-card>
  </div>
</template>

  
<script>

export default {
  data() {
    return {
      id: '1956297321778135041',
      isOpen: '否',
      withdrawNotice: ''
    }
  },
  mounted:function(){
    if(this.id){
      this.getData()
    }
  },
  methods: {
    backEvent(){
        this.$router.go(-1)
    },
    getData(){
      var ths = this
      ths.$get('/SiteConfig/queryById?id='+ths.id)
      .then(function (res) { 
          if(res.success){
            ths.withdrawNotice = res.data.withdrawNotice
            if(res.data.isOpen == '1'){
              ths.isOpen = '是'
            }
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    submitEvent() {
      const ths = this;
      var isOpen = 0;
      if(ths.isOpen == '是'){
        isOpen = 1
      }
      var data = {
        id: ths.id,
        isOpen:isOpen,
        withdrawNotice: this.withdrawNotice
      }
      ths.$post('/SiteConfig/edit?', data)
        .then(function (res) { 
            alert(res.msg)
            if(res.success){
              ths.$router.push("/Admin/SiteConfigEdit")
            }
        })
        .catch(function (err) {
          console.log(err)
        })      
      },
   }
}

</script>

<style>
.form-row{
  padding:15px 0; 
}
</style>